import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {TrueGrit} from "./TrueGrit";
import {TrueGritGameMode} from "./server/TrueGritGameMode";
import {TrueGritSound} from "./sound/TrueGritSound";
import {TrueGritGameAssets} from "./TrueGritGameAssets";
import {gsap} from "gsap";


export class TrueGritPromoPanelConfig implements PromoPanelGameConfiguration {
    private wasFeatureBuy:boolean = false;
    private lastFeature:string = "";

    constructor() {
    }

    public getActionSpinOptions():ActionSpinOptions {
        return {
            gameName:"The Border",
            hasActionSpin:true,
            graphics:{backgroundTextureName: TrueGritGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData:(response:any, bet:number, prevResponse:any):ASWinData => {
                if (response.mode === TrueGritGameMode.NORMAL){
                    this.wasFeatureBuy = response.wasFeatureBuy;
                }
                const parsedData:ASWinData = {
                    totalWin:response.accumulatedRoundWin,
                    totalSpinWinnings:this.getWin(response, bet, prevResponse),
                    wasFeatureBuy:response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin:this.isFreeSpinTriggered(response),
                    isBigWin:this.isBigWin(response),
                    winType:WINTYPE.NORMAL,
                    featureName:this.getFeatureName(response),
                    isRoundComplete:this.isRoundComplete(response),
                    isBonusEnd:this.isBonusEnd(response),
                    isWinCapHit:response.brokeTheBank
                }
                return parsedData;
            }
        };
    }

    private isBigWin(response:any):boolean {
        const win = response.totalAvalancheRoundWinnings;
        const playedBetValue = response.playedBetValue;
        let winRatio:number = Helper.ceilToDecimals((win / playedBetValue), 2);

        if (this.wasFeatureBuy) {
            const betPrice = TrueGrit.getBuyFeaturePrice();
            winRatio = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        return winRatio >= 15;
    }

    private getWin(response:any, bet:number, prevData:any):number {
        return response.totalAvalancheRoundWinnings;
    }

    private getFeatureName(response:any):string {
        if (response.mode == TrueGritGameMode.FREESPIN || response.nextMode == TrueGritGameMode.FREESPIN){
            this.lastFeature = "TORTURE SPINS";
            return "TORTURE SPINS"
        }
        if (response.mode == TrueGritGameMode.FREESPIN_SUPER || response.nextMode == TrueGritGameMode.FREESPIN_SUPER){
            this.lastFeature = "DEAD SPINS";
            return "DEAD SPINS"
        }

        //FREESPIN_AVALANCE is used for both super and regular fs avalanche. That is why we need to store the feature name like this.
        if (response.mode == TrueGritGameMode.FREESPIN_AVALANCHE || response.nextMode == TrueGritGameMode.FREESPIN_AVALANCHE || response.mode == TrueGritGameMode.FREESPIN_SUPER_AVALANCHE || response.nextMode == TrueGritGameMode.FREESPIN_SUPER_AVALANCHE){
            //I don't even think this is used in server FREESPIN_SUPER_AVALANCHE. But here just in case.
            return this.lastFeature;
        }

        return "";
    }

    private isFreeSpinTriggered(response:any):boolean {
        const isFs =  (TrueGrit.model.data.mode == TrueGritGameMode.NORMAL || TrueGrit.model.data.mode == TrueGritGameMode.NORMAL_AVALANCHE) && TrueGrit.model.data.nextMode == TrueGritGameMode.FREESPIN;
        const isSfs = (TrueGrit.model.data.mode == TrueGritGameMode.NORMAL || TrueGrit.model.data.mode == TrueGritGameMode.NORMAL_AVALANCHE) && TrueGrit.model.data.nextMode == TrueGritGameMode.FREESPIN_SUPER;

        return isFs || isSfs;
    }

    private isRoundComplete(response:any):boolean {
        return ([TrueGritGameMode.NORMAL, TrueGritGameMode.FREESPIN_SUPER, TrueGritGameMode.FREESPIN].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response:any):boolean {
        return response.nextMode === TrueGritGameMode.NORMAL && (response.mode.indexOf("NORMAL") === -1);
    }


    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN) {
            TrueGrit.soundPlayer.playSound(TrueGritSound.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            TrueGrit.soundPlayer.playSound(TrueGritSound.AS_WIN_BIG);
        }
    }

    onPlayBonusInGame(data:any):void {
        TrueGrit.keypadPlugin.hide();
        TrueGrit.model.onGame(data);
        TrueGrit.apiPlugin.slotStates.resetGameStartedAndGameServerFlag();
        TrueGrit.keypadPlugin.setWin(data.accumulatedRoundWin, true, TrueGrit.isWinBelowStake());
        TrueGrit.allReelsView.reInit();


        let restoreBoxLevel:number = 0;
        for(let i:number = 0; i < TrueGrit.model.data.botTrain.isRevealed.length; i++) {
            if(TrueGrit.model.data.botTrain.isRevealed[i] == true) {
                restoreBoxLevel++;
            }
        }
        TrueGrit.symbolBoxView.setRestoreBoxes(restoreBoxLevel);
        TrueGrit.symbolBoxView.setWildMultiplierState();

        TrueGrit.gameFlowController.start();
        TrueGrit.keypadPlugin.show();

    }



}